import React from 'react';
import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import Image from '../../Utils/getImage';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const ViewUser = ({ openviewDialog, setopenviewDialog, selectedCustomers }) => {

    //handle close
    const handleClose = () => {
        setopenviewDialog(false);
    };
    const formatDate = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };
    const formattedDOB = selectedCustomers?.dob.replaceAll("/", "-");
    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openviewDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Customer details
                    <Typography>
                        For more information, see the customer details
                    </Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className="add-employee">
                        <div className='add-employee-title'>
                            <Typography>Person info</Typography>
                        </div>
                        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: "flex-start" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                <div className="add_emloyee-upload-file">
                                    <Image src={selectedCustomers?.profile_pic || "---"} alt="employeeprofile" width={190} height={190} />
                                    <Typography variant="h5">{selectedCustomers?.name || "---"}</Typography>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                <div className='add_emloyee-content'>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Mobile number</Typography>
                                        <Typography>{selectedCustomers?.mobile || "---"}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Date Of Birth</Typography>
                                        <Typography>
                                            {formattedDOB}

                                        </Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Status</Typography>
                                        <label class="switch">
                                            <input type="checkbox" checked={selectedCustomers?.status} readOnly />
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className='add_emloyee-content' style={{ marginTop: 20 }}>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Location</Typography>
                                        <Typography>{selectedCustomers?.location || "---"}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Gender</Typography>
                                        <Typography>{selectedCustomers?.Gender || "---"}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>created Date</Typography>
                                        <Typography>
                                            {selectedCustomers?.createddDate || "---"}
                                        </Typography>
                                    </div>
                                </div>
                                <div className='add_emloyee-content' style={{ marginTop: 20 }}>
                                    {/* <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Updated Date</Typography>
                                        <Typography>{selectedCustomers?.UpdatedDate || "---"}</Typography>
                                    </div> */}
                                    {/* <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Consultations Left</Typography>
                                        <Typography
                                            style={{
                                                background: selectedCustomers?.consultations_left ? "#E1FCEF" : "#FFEDEF",
                                                color: selectedCustomers?.consultations_left ? "#14804A" : "#D1293D",
                                                padding: "5px 8px",
                                                borderRadius: "5px",
                                                textAlign: "center",
                                            }}
                                        >
                                            {selectedCustomers?.consultations_left === true ? "Yes" : "No" || "---"}
                                        </Typography>
                                    </div> */}
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default ViewUser;